export default __webpack_public_path__ + "static/media/injury-recovery.00fc65f1.jpg";